import { IPage, registerPage } from '../Components/Page';
import Home from './Home';
import { Fragment, useState } from 'react';
import { useInitAsync } from '../Utils';
import Field from '../Components/Field';
import Button from '@mui/material/Button';
import "./About.scss"
import { isNativeDevice } from '../Platform';
import { useOperation } from '../Hooks/OperationContext';


export function AboutContent() {

    const [data, setData] = useState({
        serverVersion: "",
        cacheVersion: ""
    })

    const op = useOperation();

    useInitAsync(async () => {

        const cacheVersions: string[] = [];
        for (const key of await caches.keys()) {
            const parts = key.split(":");
            if (parts.length > 1)
                cacheVersions.push(parts[1]);
        }

        const json = await (await fetch(`/manifest.json`)).text();
        const manifest = JSON.parse(json);

        setData({
            cacheVersion: cacheVersions.length == 0 ? "N/A" : cacheVersions.join(", "),
            serverVersion: manifest.version
        })
        
    });

    const update = async () => {
        for (const key of await caches.keys())
            await caches.delete(key);
        window.location.reload();
    }

    const reset = async () => {

        if (!await op.confirmAsync("Attenzione, tutte le impostazione verrano resettate, e i dati offline persi. Continuare?"))
            return false;

        op.begin();

        try {
            for (const key of await caches.keys())
                await caches.delete(key);

            while (localStorage.length > 0)
                localStorage.removeItem(localStorage.key(0));

            await new Promise<void>((res, rej) => {
                const req = indexedDB.deleteDatabase("GateKeeper");
                req.onsuccess = () => {
                    console.log("success");
                    res();
                }
                req.onerror = rej;
                req.onblocked = () => {
                    console.log("blocked");
                }
            });

            window.location.href = "/events";

            window.location.reload();
        }
        finally {
            op.end();
        }
    }

    let nativeVer = "N/A";
    try {
        nativeVer = nativeDevice.getVersion();
    }
    catch (e) {
        console.error(e);   
    }

    return (
        <Fragment>
            <header>
                About
            </header>
            <fieldset>
                <Field label="Cache Version">{data.cacheVersion}</Field>
                <Field label="Server Version">{data.serverVersion}</Field>
                <Field label="Cur Version">{localStorage.getItem("AppVer")}</Field>
                <Field label="Host">{window.location.host}</Field>
                {isNativeDevice() && <Field label="Android App Version">{nativeVer}</Field>}
            </fieldset>
            <div className="actions">
                <Button variant="contained" onClick={update}>Aggiorna</Button>
                {isNativeDevice() && <Button variant="contained" onClick={() => nativeDevice.showLicence()}>Licenza</Button>}
                <Button variant="contained" onClick={reset}>Reset</Button>
            </div>
        </Fragment>
    );
}

const About: IPage = {

    name: "about",
    title: "About",
    route: "/about",
    content: <AboutContent />,
    container: Home,
    appBar: { backVisible: true }
};

registerPage(About);

export default About;